import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AlertNewSnakbarService } from '@app/core/services/alert-new-snakbar.service';
import { KycVerificationService } from '@app/shared/services/kyc-verification.service';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class VerificationGuard {
	constructor(
		private kycVerificationService: KycVerificationService,
		private alertNewSnakbarService: AlertNewSnakbarService,
		private router: Router,
		private translate: TranslateService,
	) { }

	private getTranslation(key: string, name?: string, value?: number): string {
		let text = '';
		this.translate.get(key, { name, value }).subscribe((translatedText: string) => {
			text = translatedText;
		});
		return text;
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const data = route.data['requestType'];
		if (this.kycVerificationService.hasFetchedKycStep) {
			const needVerify = this.kycVerificationService.getNeedVerifyItems();
			if (needVerify) {
				this.alertNewSnakbarService.snackBarError('DASHBOARD_NEW.KYC_VERIFICATION.ALERT_KYC_TEXT',
					'DASHBOARD_NEW.KYC_VERIFICATION.ALERT_KYC_TITLE',
					`<a type="button" class="btn-tc btn-primary-new btn-verify-alert mat-mdc-unelevated-button size-lg btn-has-one-icon" 
						mat-flat-button [disableRipple]="true" appMousePress>
						<div class="mdc-button__label">${this.getTranslation('DASHBOARD_NEW.KYC_VERIFICATION.AUTHENTICATION')}
						<i class="ico-arrow-left"></i>
						</div>
					</a>`,
					() => {
						this.router.navigate(['/kyc-auth']);
					});
				this.router.navigate(['/kyc-auth']);
			}
			return !needVerify;
		}
	}

}
